var map = {
	"./en_us.png": "f940",
	"./es_spa.png": "24ab",
	"./fr_fr.png": "4ee5",
	"./it_it.png": "3518",
	"./ko_ko.png": "aede",
	"./ms_my.png": "650f",
	"./vn_vn - 副本.png": "f3bc",
	"./vn_vn.png": "6ac2",
	"./zh_cn.png": "d435"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79a4";